module.exports = __webpack_public_path__ + "img/final_center_talk.6520014d.gif";